import React, { useState } from "react";
import aboutUsImage from "../../assets/images/about-us.png";
import website from "../../assets/images/website.svg";
import computer from "../../assets/images/computer.svg";
import mobile from "../../assets/images/mobile.svg";
import rocket from "../../assets/images/rocket.svg";
import eplise from "../../assets/images/elipse.svg";
import quote from "../../assets/images/quote.svg";
import "./about.css";

export default function About() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const cards = [
    {
      icon: website,
      header: "Global Payments",
      description:
        "You can securely receive Gifts from your funs from anywhere in the world, offering you more flexibility and convenience.",
      backgroundColor: "#FFDED4",
    },
    {
      icon: computer,
      header: "No Hefty Fees!",
      description:
        "Best of all, you can enjoy this service without any hefty fees. Seamless transactions and cost-effective solutions are now at your fingertips",
      backgroundColor: "#FFEED4",
    },
    {
      icon: mobile,
      header: "Mobile Privacy",
      description:
        "We take your mobile privacy seriously. Our platform is designed to protect your personal information with the highest security standards, ensuring your data remains safe and secure at all times. Enjoy peace of mind knowing that your privacy is our top priority.",
      backgroundColor: "#D4F0FF",
    },
    {
      icon: rocket,
      header: "Fast & Reliable",
      description:
        "Delivering fast and reliable services to boost your business growth.",
      backgroundColor: "#FFD4D4",
    },
  ];

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? cards.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === cards.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="about">
      <div className="about__responsive-row">
        <div className="about__image-container">
          <img src={aboutUsImage} alt="About Us" className="about__image" />
        </div>

        <div className="about__text-container">
          <div className="about__header-text">
            <p className="about__title">About Us</p>
            <p className="about__subtitle">
              Content Creators are{" "}
              <span className="about__subtitle-underline">Our Business</span>
            </p>
          </div>
          <div className="about__image-container-mobile">
            <img
              src={aboutUsImage}
              alt="About Us"
              className="about__image-mobile"
            />
          </div>
          <div className="about__content-wrap">
            <p className="about__content">
              With Tipserve, content creators can easily receive Tips or Gifts
              from their audience without worrying about hefty fees or privacy
              concerns. It does not matter whether you have ZERO FOLLOWERS, Just
              create your personalized payment link, share it in your bio or
              comments, and let those that love your craft send their support
              directly to your MOBILE. Don't let platforms take almost all your
              earnings. Instead, download our APP. Plus, we’re expanding our
              payment options to allow tips from supporters around the world.
              It’s a simple, secure, and free way to maximize your earnings and
              connect with your audience.
            </p>
          </div>
        </div>
      </div>
      <div className="about__zenpay-section">
        <div className="about__content-wrapper">
          <div className="about__wrapper-content">
            <p className="about__zenpay-title">
              Why Choose{" "}
              <span className="about__zenpay-title-mobile">Tipserve</span>
            </p>
            <p className="about__zenpay-subtitle">
              <span className="about__zenpay-subtitle-prefix">For Your</span>{" "}
              <span className="about__zenpay-subtitle-underline">Earnings</span>
            </p>
          </div>
          <div className="about__carousel-container">
            <div className="about__carousel">
              <div
                className="about__carousel-wrapper"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {cards.map((card, index) => (
                  <div key={index} className="about__card">
                    <div
                      className="about__card-icon-container"
                      style={{ backgroundColor: card.backgroundColor }}
                    >
                      <img
                        src={card.icon}
                        alt={`Icon ${index + 1}`}
                        className="about__card-icon"
                      />
                    </div>
                    <h2 className="about__card-header">{card.header}</h2>
                    <p className="about__card-description">
                      {card.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="about__carousel-buttons">
              <button className="about__carousel-prev" onClick={handlePrev}>
                ‹
              </button>
              <button className="about__carousel-next" onClick={handleNext}>
                ›
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
